"use client";

import React from "react";
import { Typography } from "@aph/ui-lib-humanx";
import NextLink from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import Slider, { Slide } from "@/components/Slider";
import IconRight from "$/icons/icon-right.svg";
import IconLeft from "$/icons/icon-left.svg";
import routes from "@/helpers/router";
import VideoCard from "@/components/PageVideoListing/Components/VideoCard";
import { DeviceInfo } from "@/interface/deviceInfo";
import { ResourceVideosComponent, Video } from "@/components/PageAllResources/api/interface";
import styles from "../../PageAllResources.module.scss";

interface VideoComponentProps {
  data: ResourceVideosComponent;
  userAgent?: DeviceInfo;
  categorySlug?: string;
}

const VideoComponent: React.FC<VideoComponentProps> = ({ data, userAgent, categorySlug }) => {
  const desktopItems = 4;
  const router = useRouter();
  const videos: Video[] = data?.data || [];

  const searchParams = useSearchParams();
  const queryString = searchParams?.toString();
  const seeAllLink = `${routes.resourcesListing("video", categorySlug)}${queryString ? `?${queryString}` : ""}`;

  return (
    <div className={styles.videoContainer}>
      <div className={styles.videoInner}>
        <div className={styles.head}>
          <Typography className={styles.heading}>
            All{" "}
            <Typography className={styles.heading} component="span" varient="body1" fontWeight="bold">
              videos
            </Typography>
          </Typography>
          {!!videos?.length && (
            <NextLink href={seeAllLink} prefetch={false} className={styles.primaryLink}>
              See all
            </NextLink>
          )}
        </div>
        {!!videos?.length ? (
          <div className={styles.videoContent}>
            <Slider
              slidesToShow={userAgent?.isDesktop ? desktopItems : 1.1}
              showDots={false}
              center={!userAgent?.isDesktop}
              columnGap={userAgent?.isDesktop ? 20 : 27}
              autoplay={userAgent?.isDesktop ? Boolean(videos?.length > desktopItems) : Boolean(videos?.length > 1)}
              showArrows={userAgent?.isDesktop}
              nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
              prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
            >
              {videos?.map((videoData: Video, index) => {
                const { Slug, Title, Video, AuthorName, Tags } = videoData;
                const redirectUrl = routes.video(Slug);

                return (
                  <Slide index={index} key={index}>
                    <VideoCard
                      thumbNailImage={`${Video?.data?.attributes?.url}/ik-thumbnail.jpg`}
                      title={Title}
                      tags={Tags}
                      AuthorName={AuthorName}
                      userAgent={userAgent}
                      redirectUrl={redirectUrl}
                      onClick={() => router.push(redirectUrl)}
                      key={Slug}
                      isImageEagerload={userAgent?.isDesktop ? index <= 3 : index <= 1}
                    />
                  </Slide>
                );
              })}
            </Slider>
          </div>
        ) : (
          <div className={styles.noResourcesFound}>No videos available!</div>
        )}
      </div>
    </div>
  );
};

export default VideoComponent;
